<template>
    <div class="whatsapp-chat-starter">
        <div>
            <label for="phoneNumber">Telefon Numarası</label>
            <small>Ülke kodu ile birlikte boşluk girmeden sadece rakamlar ile</small>
            <input type="text" v-model="phoneNumber" />
        </div>
        <div>
            <label for="channelId">Kanal</label>
            <small>Hangi kanal üzerinden chat başlatmak istiyorsun</small>
            <ChannelPicker
                :allowed-types="['whatsapp-qr', 'whatsapp-v2', 'whatsapp-business-api']"
                :autoSelectFirst="false"
                v-model="channelId"
            />
        </div>

        <footer>
            <SupsisButton primary @click="startChat"> Chat Başlat</SupsisButton>
        </footer>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import ChannelPicker from "../../../../components/pickers/ChannelPicker.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import ChatWatcher from "../../../../ChatWatcher";

export default Vue.extend({
    name: "WhatsappChatStarter",
    components: { SupsisButton, ChannelPicker },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            whatsappChannels: (state) => state.channel.channels.filter((x) => x.type.startsWith("whatsapp")),
        }),

        ...mapGetters({}),
    },
    props: {
        defaultPhoneNumber: {
            type: String,
        },
        defaultChannelId: {
            type: String,
        },
        phoneNumberOverride: {
            type: Boolean,
            default: true,
        },
        channelOverride: {
            type: Boolean,
            default: true,
        },
        defaultName: {
            type: String,
        },
        defaultEmail: {
            type: String,
        },
    },
    data() {
        return {
            phoneNumber: this.defaultPhoneNumber,
            channelId: this.defaultChannelId,
            message: "",
            isSending: false,
        };
    },
    methods: {
        checkValidation() {
            //phone number validation rules = only numeric and length 6
            if (!this.phoneNumber || this.phoneNumber.length < 6 || !/^\d+$/.test(this.phoneNumber)) {
                this.$message.error("Telefon numarası hatalı");
                return false;
            }
            if (!this.channelId) {
                this.$message.error("Kanal seçiniz");
                return false;
            }
            return true;
        },
        async startChat() {
            console.log("startChat", {
                phoneNumber: this.phoneNumber,
                channelId: this.channelId,
                validate: this.checkValidation(),
            });
            if (!this.checkValidation()) return;
            const channel = this.whatsappChannels.find((x) => x._id === this.channelId);
            ChatWatcher.startChatImmediately({
                whatsappNumber: this.phoneNumber,
                channelId: this.channelId,
                channelType: channel.type,
                name: this.defaultName,
                email: this.defaultEmail,
            });
            this.$emit("close");
        },
    },
});
</script>

<style scoped lang="scss">
.whatsapp-chat-starter {
    display: flex;
    flex-direction: column;
    padding: 20px;

    h1 {
        font-size: 20px;
        margin-bottom: 20px;
    }

    div {
        margin-bottom: 20px;

        label {
            font-size: 14px;
            margin-bottom: 5px;
        }

        small {
            font-size: 12px;
            color: #999;
            margin-bottom: 5px;
        }

        input {
            width: 100%;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 5px;
        }
    }

    footer {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
